import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/app/leagues/[tournamentId]/schedule/rounds/[roundId]/games/[gameId]/RefreshedOfficialTicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HalfPageAd"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/Ad/HalfPageAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeaderBoardAd"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/Ad/LeaderBoardAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RectangleAd"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/Ad/RectangleAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewFilterArea"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/filter/NewFilterArea.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/layout/CalendarImport.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/layout/ContentHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/router/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyTournamentButton"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/components/tournament/MyTournamentButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Gtag"] */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/lib/gtm.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/dhb-handball-net/dhb-handball-net/web/node_modules/next/dist/client/link.js");
